#@import GliveBooking.Presenters.Time
#@export GliveBooking.Views.Time

class GliveBooking.Views.Time extends BookingV2.Views.Base

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.Time

  templateName: 'time'

  tagName: 'li'

  events:
    'click': 'select'

  select: ->
    @trigger 'select', @model

  attributes: ->
    'data-bhc': @getPresenter()?.bhc()
